import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  Text,
} from '@flatfile/baseline'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActiveEnvironment } from '../../hooks/useEnvironments'
import { useIdentity } from '../../hooks/useIdentity'
import { CreateNewAppForm } from './CreateNewAppForm'

export default function CreateNewApp(
  props: { mini: boolean; title?: string; iconPlus?: boolean; hidden?: boolean; autoOpen?: boolean } = {
    mini: false,
  }
) {
  const { environment } = useActiveEnvironment()
  const { identity, hasPermission } = useIdentity()
  const [opened, setOpened] = useState(props.autoOpen || false)
  const nav = useNavigate()

  // If autoOpen is true, open the modal when the component mounts
  useEffect(() => {
    if (props.autoOpen) {
      setOpened(true)
    }
  }, [props.autoOpen])

  const open = () => setOpened(true)
  const close = () => setOpened(false)

  const closeNewAppModal = () => {
    close()
    nav(`/home`)
  }

  return (
    <>
      <Dialog open={opened} onOpenChange={(isOpen) => !isOpen && closeNewAppModal()}>
        <DialogContent className={!environment.isProd ? 'max-w-4xl' : 'max-w-md'}>
          <DialogTitle>New App</DialogTitle>
          <CreateNewAppForm></CreateNewAppForm>
        </DialogContent>
      </Dialog>
      {!props.autoOpen &&
        hasPermission({ resource: identity.account, permissionKey: 'app:create' }) &&
        (props.hidden ? null : props.mini ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type='button'
                className='flex items-center justify-center w-5 h-5 rounded border border-gray-300'
                onClick={() => (opened ? close() : open())}
              >
                <Icon name='plus-small' size={16} />
              </button>
            </TooltipTrigger>
            <TooltipContent className='flex items-center px-2 py-1'>
              <Text variant='body' className='text-sm'>
                Build a custom App
              </Text>
            </TooltipContent>
          </Tooltip>
        ) : (
          <Button
            onClick={() => (opened ? close() : open())}
            icon={props.iconPlus ? 'plus-small' : undefined}
            iconProps={props.iconPlus ? { size: 16, className: 'mr-2' } : undefined}
          >
            {props.title || 'New App'}
          </Button>
        ))}
    </>
  )
}
